module.exports = __webpack_public_path__ + "static/media/Volunteer-Network.8f55ddfd.png";